import { useState } from 'react';
import weddingRequestService from 'src/services/api/weddingRequestService';
import Swal from 'sweetalert2';
import WeddingRequestAnswers from '../components/WeddingRequestAnswers';

const AdminWeddingRequestAnswers = (props) => {
  const { answers, set_showWeddingRequestForm, getInfo, allWeddingFacilitators } = props;
  const [sending, set_sending] = useState(false);
  const [admin_editing, set_admin_editing] = useState(false);

  const editAnswerVars = (key, value) => {
    let body = {
      id: answers?.id,
      male_guest_id: answers?.MaleGuest?.id,
      female_guest_id: answers?.FemaleGuest?.id,
    };
    if (key === 'facilitator') body.facilitator_guest_id = value;
    if (key === 'pastor') body.pastor_guest_id = value;
    if (key === 'deleted') body.deleted = true;

    set_sending(true);
    weddingRequestService
      .WeddingEditRequest(body)
      .then((response) => {
        set_sending(false);
        if (response.data.success) {
          getInfo();
          admin_editing(false);
        }
      })
      .catch((error) => {
        set_sending(false);
        Swal.fire(error?.response?.data?.message);
      });
  };

  const deleteRequest = () =>
    Swal.fire({
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar',
      showCancelButton: true,
      title: `¿Está seguro que quieres eliminar esta solicitud?`,
    }).then(async (result) => {
      if (result.value) {
        editAnswerVars('deleted');
        set_showWeddingRequestForm(null);
      }
    });

  return (
    <WeddingRequestAnswers
      set_showWeddingRequestForm={set_showWeddingRequestForm}
      answers={answers}
      allWeddingFacilitators={allWeddingFacilitators}
      editAnswerVars={editAnswerVars}
      sending={sending}
      deleteRequest={deleteRequest}
      set_admin_editing={set_admin_editing}
      admin_editing={admin_editing}
      role={'admin'}
      getInfo={getInfo}
    />
  );
};

export default AdminWeddingRequestAnswers;
